import { render, staticRenderFns } from "./NormalVideo.vue?vue&type=template&id=edebdc8c"
import script from "./NormalVideo.vue?vue&type=script&lang=ts"
export * from "./NormalVideo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports